import { useEffect } from "react";

const useLogoutSync = () => {
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === "logout") {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("verified");
        localStorage.removeItem("doctor");
        localStorage.removeItem("patient");

        // Redirect without React Router
        window.location.href = "/login";
      }

      if(event.key  ===  "user"){

          window.location.href = "/";

      }


    };

    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, []);
};

export default useLogoutSync;
